module.exports =
  accepted: (vars) -> d3.keys vars.types
  value:    "auto"
